module.exports = __webpack_public_path__ + "img/users.4e02b6fe.svg";